import { GeolocationInfo } from './geolocation';

export enum PetGender {
  Male = 1,
  Female,
  Unknown,
}

export enum PetSpecies {
  Dog = 'Dog',
  Cat = 'Cat',
  Horse = 'Horse',
  Rabbit = 'Rabbit',
}

export enum PetSpeciesFilterableType {
  Other,
  Dog,
  Cat,
  Horse,
  Rabbit,
}

export enum PetStatus {
  Alive = 1,
  Deceased,
  Unknown,
}

export enum PetResidenceStatus {
  AtHome,
  Lost,
  Stolen,
  Unknown,
}

export enum PetPerksAppearanceOrder {
  Top = 1,
  Bottom,
}

export enum PetPerksAppearancePosition {
  TopRight,
  BottomLeft,
  PetplanCase,
}

export interface Pet {
  readonly id: number;
  name: string;
  dob: Date;
  species: string;
  speciesCode: number;
  speciesFilter: PetSpeciesFilterableType;
  breed: string;
  breedVenomCode: number;
  implantDate: Date;
  gender: PetGender;
  neutered: boolean;
  coloursMarkings: string;
  existingConditions: string;
  chipNumber: string;
  imageUrl: string;
  imageId: string;
  status: PetStatus;
  instagram: string;
  residence: PetResidenceStatus;
  readonly keeperId: number;
  missingPetReports: PetMissingReport[];
  updated: Date;
  archived?: boolean;
  created?: Date;
  isOutdoors?: boolean;
  readonly hasQrCodeTag: boolean;
  isTokPaymentRequired?: boolean;
}

export interface PetPublic {
  readonly id: number;
  name: string;
  species: string;
  speciesFilter: PetSpeciesFilterableType;
  breed: string;
  gender: PetGender;
  neutered: boolean;
  coloursMarkings: string;
  imageUrl: string;
  imageId: string;
  readonly keeperId: number;
}

export interface PetMissingReportInfo {
  date: Date;
  notes: string;
  location: GeolocationInfo;
  imageUrl: string;
  imageId: string;
}

export enum PetMissingReportType {
  Missing = 1,
  Stolen,
}

export enum PetMissingReportStatus {
  Draft = 1,
  AwaitingModeration,
  Open,
  ClosedRejected,
  AwaitingClosureFound, // This will be visible only to the keeper. Other users will not be able to access the page.
  AwaitingClosureDeceased, // This will be visible only to the keeper. Other users will not be able to access the page.
  ClosedFound,
  ClosedDeceased,
}

export interface PetMissingReport {
  id?: number;
  lastSeen: PetMissingReportInfo;
  reportType: PetMissingReportType;
  reportStatus?: PetMissingReportStatus;
}

export interface PetMissingReportPublic {
  id: number;
  pet: PetPublic;
  lastSeen: PetMissingReportInfo;
  reportType: PetMissingReportType;
  reportStatus: PetMissingReportStatus;
  seenLocations: PetMissingReportInfo[];
}

export interface PetRehomingRequest {
  name: string;
  species: string;
  breed: string;
  gender: PetGender;
  chipNumber: string;
  extraInfo: string;
  vetCode: string;
  existingKeeper: {
    name: string;
    phoneNumber: string;
  };
  instagram?: string;
}
